export const getDifficultyLabel = (difficulty: number) => {
  if (difficulty >= 66) {
    return 'Hard'
  }
  if (difficulty >= 33 && difficulty < 66) {
    return 'Medium'
  }
  return 'Easy'
}
